import { DesignerRegistrationForm } from "@/features/authentication/components/designer-registration-form";
import { registerDesigner } from "@/features/authentication/service.server";
import { designerRegistrationFormValidationSchema } from "@/features/authentication/validation.server";
import { LegalTemplateRenderer } from "@/services/legal-template-renderer";
import { formatErrorMessagesForErrorResult } from "@/utils/format-error-messages-for-error-result";
import { Text } from "@mantine/core";
import { LegalDocumentType } from "@prisma/client";
import { ActionArgs, json, redirect } from "@remix-run/node";
import { useActionData, useNavigation } from "@remix-run/react";
import format from "date-fns/format";
import { inputFromForm } from "domain-functions";
import { getClientIPAddress } from "remix-utils";

export default function RegisterDesignerRoute() {
	const actionData = useActionData<typeof action>();
	const navigation = useNavigation();

	return (
		<div>
			<Text mt="sm" size="sm" align="center">
				Designers can be students, recent graduates or working professionals
				within in the field of industrial/product design. Please note that you
				will be required to provide documentation of your studies as a designer.
			</Text>
			<DesignerRegistrationForm
				errors={
					actionData?.success === false ? actionData.inputErrors : undefined
				}
				formErrors={
					actionData?.success === false ? actionData.errors : undefined
				}
				loading={navigation.state === "submitting"}
			/>
		</div>
	);
}

export async function loader() {
	const privacyPolicyRenderer = new LegalTemplateRenderer(
		LegalDocumentType.PRIVACY_POLICY,
		1
	);
	const termsAndConditionsRenderer = new LegalTemplateRenderer(
		LegalDocumentType.TERMS_AND_CONDITIONS,
		1
	);

	const [privacyPolicy, termsAndConditions] = await Promise.all([
		privacyPolicyRenderer.render({
			currentDate: format(new Date(), "dd/MM/yyyy"),
		}),
		termsAndConditionsRenderer.render({
			currentDate: format(new Date(), "dd/MM/yyyy"),
		}),
	]);

	return json({
		privacyPolicy: privacyPolicy.unwrapOr("Failed to load privacy policy"),
		termsAndConditions: termsAndConditions.unwrapOr(
			"Failed to load terms and conditions"
		),
	});
}

export async function action({ request }: ActionArgs) {
	const registerDesignerResult = await registerDesigner(
		await inputFromForm(request),
		{
			ip: getClientIPAddress(request.headers),
		}
	);

	if (!registerDesignerResult.success) {
		return json(
			formatErrorMessagesForErrorResult(
				registerDesignerResult,
				designerRegistrationFormValidationSchema
			)
		);
	}

	return redirect("/register/success");
}
